<template>
  <div>
    <v-dialog
      v-model="applicationDialog"
      persistent
      width="900px"
      class="rounded-xl"
    >
      <v-card class="rounded-lg">
        <v-card-title>
          <v-toolbar elevation="0">
            <v-toolbar-title
              >{{ user.profile_id }} Application(s)</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="columns" :items="applications">
            <template v-slot:[`item.ApplicationDateTime`]="{ item }">
              {{ formatDate(item?.ApplicationDateTime, 8) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions v-if="!applications.length">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            :disabled="loading"
            @click="createNewProfileApplication"
            >create a new application for profile {{ user.profile_id }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DateMixin from "../../../mixins/DateMixin";
export default {
  props: {
    applicationDialog: {
      required: true,
      type: Boolean,
    },
    user: {
      type: Object,
      required: true,
    },
    applications: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [DateMixin],
  data: () => ({}),
  computed: {
    columns: {
      get() {
        return [
          {
            text: "Application No.",
            align: "start",
            sortable: false,
            value: "Code",
          },
          {
            text: "Application Date",
            align: "start",
            sortable: false,
            value: "ApplicationDateTime",
          },
          {
            text: "Billed Amount",
            align: "start",
            sortable: false,
            value: "Amount",
          },
          {
            text: "Status",
            align: "start",
            sortable: false,
            value: "status",
          },
        ];
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeApplicationDialog", false);
    },
    createNewProfileApplication() {
      this.$emit("createNewProfileApplication");
    },
  },
};
</script>

<style></style>
